package com.wintermar.inspection.feature.domain.model.answer

import com.wintermar.inspection.graphql.type.InspectionStatus
import kotlinx.serialization.Serializable

@Serializable
data class CompleteAnswerModel(
    val inspectionId: String = "",
    val templateName: String = "",
    val totalFindings: Int = 0,
    val totalFiles: Int = 0,
    val lastUpdated: String = "",
    val inspectionStatus: InspectionStatus = InspectionStatus.UNKNOWN__,
    val vesselName: String = "",
    val totalAnswer: Int = 0,
    val totalQuestion: Int = 0
)
